export default __webpack_public_path__ + "static/media/city5.9fd3c2b4.webp";